import * as amplitude from "@amplitude/analytics-react-native"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import { SnackBarM } from "@common/components/alert/snackbar/SnackBar"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import { IconImageM } from "@common/components/icons/IconsM"
import { Menu3Point } from "@common/components/menu/Menu3Point"
import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import { useDisconnectFromLive } from "../../engine/live/room/useDisconnectFromLive"
import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"
import { useScreenShare } from "@common/hooks/livekit/useScreenShare"
import { useSwitchCamera } from "@common/hooks/livekit/useSwitchCamera"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { useCameraStateRecorder } from "../../engine/live/room/cameraTelemetry"
import { ControlBarM } from "@common/livekit/components-web/ControlBarM"
import { liveButtonStyle } from "@common/livekit/components-web/TrackToggleM"
import { LayoutToggleM } from "@common/livekit/components/LayoutToggleM"
import PermissionBanner from "@common/livekit/components/PermissionBanner"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import {
    playASound,
    removeInCallUsers,
    setFocusScreenShare,
    setInCallUsers,
    setIsLiveModeEnabled,
    setIsTyping,
    setLiveParticipants,
    setTypingUser,
} from "@data/redux/actions/liveMode"
import LiveEventBuffer from "@data/services/LiveEventBuffer"
import { liveServiceV2 } from "@data/services/liveServiceV2"
import { useNavigation, useRoute } from "@react-navigation/native"
import moment from "moment"
import React, { useContext, useEffect, useRef } from "react"
import { Dimensions, Platform, View } from "react-native"
import { ActivityIndicator, Badge } from "react-native-paper"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import FontAwesome6 from "react-native-vector-icons/FontAwesome6"
import { connect, useSelector } from "react-redux"
import live from "../../../assets/icons/generic/live.png"
import { setCallPortal } from "../../data/redux/actions/liveMode"
import { liveService } from "../../data/services/liveService"
import { hasRole } from "../../data/utility/ability"
import { openCalendly } from "../../data/utility/Utils"
import { findClosestNextOccurrence } from "../../student/account/onboarding/LiveRoomCard"
import TutorResources from "../../tutor/home/tutorResources/TutorResources"
import GenerateActivityModal from "../../tutor/students/GenerateActivityModal"
import IconButtonM from "../components/button/IconButtonM"
import { theme } from "../theme/theme"
import LiveHelpModal from "../liveMode/LiveHelpModal"
import TroubleshootingPanel, { PROBLEMS } from "../liveMode/TroubleshootingPanel"
import { useTroubleshootingDetection } from "../hooks/livekit/useTroubleshootingDetection"
import { useTutorCameraObstructionDetection } from "../hooks/livekit/useTutorCameraObstructionDetection"
import LiveSessionDialogComponent from "./LiveSessionDialogComponent"

export const CustomIconButton = ({
    icon,
    disabled,
    onPress,
    loading,
    badgeCount,
    containerStyle = {},
    useFA6 = false,
    ...rest
}) => (
    <View style={{ position: "relative", ...containerStyle }}>
        {useFA6 ? (
            <TouchableRippleM
                disabled={disabled}
                style={{
                    ...liveButtonStyle,
                    backgroundColor: theme.colors.lighter + "aa",
                    width: 50,
                    height: 44,
                    padding: 0,
                }}
                onPress={onPress}
            >
                <FontAwesome6
                    name={icon}
                    size={24}
                    color={theme.colors.primary}
                />
            </TouchableRippleM>
        ) : (
            <IconButtonM
                icon={icon}
                disabled={disabled}
                style={{
                    height: 44,
                    width: 50,
                }}
                size={24}
                onPress={onPress}
                loading={loading}
                {...rest}
            />
        )}
        {badgeCount > 0 && (
            <Badge
                size={15}
                style={{
                    backgroundColor: theme.colors.error,
                    color: theme.colors.white,
                    position: "absolute",
                    top: 4,
                    right: 4,
                }}
            />
        )}
    </View>
)

export const onExitPress = (action1, action2, isFinalized, tutor, user) => {
    const standardTitle = "Veux-tu vraiment quitter ?"
    const standardButton1 = "Quitter le LIVE"

    const studentTitle = standardTitle
    const studentText = isFinalized
        ? null
        : `${tutor?.display_name} n'a pas encore mis fin à la session`
    const studentButton1 = standardButton1

    const tutorTitle = isFinalized
        ? standardTitle
        : "Veux-tu mettre fin au LIVE ?"
    const tutorText = isFinalized
        ? null
        : `Si tu clôtures le LIVE, il ne sera plus accessible aujourd'hui.`
    const tutorButton3 = isFinalized ? standardButton1 : "Quitter sans clôturer"
    const tutorButton1 = isFinalized ? null : "Clôturer et envoyer rapports"

    const title = hasRole(user, "student") ? studentTitle : tutorTitle
    const text = hasRole(user, "student") ? studentText : tutorText
    const button1 = hasRole(user, "student") ? studentButton1 : tutorButton1
    const button3 = hasRole(user, "student") ? null : tutorButton3

    DialogM.show({
        champion: "zoe",
        variant: "main",
        text1: title,
        text2: text,
        buttonText1: button1,
        // Sans libellé, DialogM affiche « OK », branché ici sur la clôture :
        // dans un live déjà clôturé, il la relancerait pour un refus serveur.
        hideButton1: !button1,
        buttonColor1: hasRole(user, "student")
            ? theme.colors.primary
            : theme.colors.error,
        onPress: hasRole(user, "student") ? action1 : action2,
        buttonText2: "Annuler",
        buttonText3: button3,
        buttonColor3: theme.colors.primary,
        onPress3: hasRole(user, "student") ? null : action1,
        exitButton: true,
    })
}

const OutOfAppAlert = (props) => {
    const { user, participants } = props
    const isOnline = !!participants?.find((x) => x === user?.id)
    const outOfAppIds = useSelector((state) => state.liveMode?.outOfAppIds)
    const isOutOfApp = outOfAppIds?.find((id) => id === user?.id)
    const activityCameraOnIds = useSelector(
        (state) => state.liveMode?.activityCameraOnIds
    )
    const isActivityCameraOn = activityCameraOnIds?.find(
        (id) => id === user?.id
    )
    const clearTimeoutRef = useRef()
    const delayForAlert = 30

    useEffect(() => {
        if (!isOnline) {
            clearTimeout(clearTimeoutRef.current)
        }
    }, [isOnline])
    useEffect(() => {
        if (isOutOfApp && !isActivityCameraOn) {
            clearTimeoutRef.current = setTimeout(() => {
                SnackBarM.show({
                    text1: `👻️ ${user?.display_name} est sorti.e de son écran d'activité depuis ${delayForAlert} secondes`,
                    duration: 4000,
                })
            }, delayForAlert * 1000)
        } else {
            clearTimeout(clearTimeoutRef.current)
        }
    }, [isOutOfApp, isActivityCameraOn])
    return null
}

const LiveModeFooter = (props) => {
    const {
        buttonsDisabled = false,
        headerNavigation,
        headerRoute,
        setMiniMode = () => {},
        pinnedMode,
        setPinnedMode,
        height = 60,
    } = props

    const navigation = headerNavigation ?? useNavigation()
    const route = headerRoute ?? useRoute()
    const liveSession = props.currentLiveSession
    const isIndividual = liveSession?.live_room?.type === "individual"
    const isTrial = liveSession?.live_room?.type === "trial"

    const studentParticipants =
        liveSession?.users?.filter((user) => !user?.is_tutor) ?? []

    const [openGoldenRules, setOpenGoldenRules] = React.useState(false)
    const [showGenerateActivityModal, setShowGenerateActivityModal] =
        React.useState(false)
    const {
        micWarning,
        camWarning,
        detectedProblem,
        micLevel,
        permissionsGranted,
        requestPermissions,
        showHelpModal,
        setShowHelpModal,
        showTroubleshootingPanel,
        setShowTroubleshootingPanel,
        troubleshootInitialProblem,
        openTroubleshooting,
    } = useTroubleshootingDetection({ isSoundMode: true })

    const color = buttonsDisabled ? theme.colors.light : theme.colors.lighter
    const { switchCamera } = useSwitchCamera()
    const {
        isScreenShareEnabled,
        toggleScreenShare,
        isLoading: isScreenShareLoading,
        canScreenShare,
    } = useScreenShare()

    // Native pairs sharing with "Présenter" mode; on web that mode belongs to
    // the Présenter button, and the footer shares like the wide control bar.
    const onScreenSharePress = async () => {
        if (isScreenShareLoading) return
        await toggleScreenShare()
        if (!IS_WEB) props.setFocusScreenShare(!props.isFocusScreenShare)
    }

    const dimensions = useContext(DimensionsContext)
    const isFinalized = props.todayLiveSessionLogs?.find(
        (log) => log?.action === "finalized_live_session"
    )

    const closestNextOccurrence = findClosestNextOccurrence([liveSession])

    const liveMoment = closestNextOccurrence?.date
        ? moment(closestNextOccurrence?.date)
        : null

    useApiStatus(liveService.raiseHand, false, true, () => {})

    // Initialize the event buffer for batched event syncing (safe to call multiple times)
    useEffect(() => {
        if (props.liveSessionId && props.user?.id) {
            LiveEventBuffer.getInstance().init(
                props.liveSessionId,
                props.user.id
            )
        }
    }, [props.liveSessionId, props.user?.id])

    useEffect(() => {
        if (hasRole(props.user, "tutor")) noNotesStudentsList()
    }, [props.notes, props.inCallUsers])

    const { sendLiveKitData: triggerFinalizeLive } = useLiveKitEventSender()

    const noNotesStudentsList = () => {
        let notes = []
        liveSession?.users
            ?.filter((user) => !user?.is_tutor)
            ?.forEach((user) => {
                if (
                    !user?.tutor_notes?.find(
                        (n) => moment(n?.created_at).day() === liveMoment.day()
                    )
                )
                    notes.push(user.display_name)
            })
    }

    const exit = () => {
        if (hasRole(props.user, "tutor"))
            props.apiRequest(liveService.leaveLiveSession, {
                id: props.liveSessionId,
            })
        if (hasRole(props.user, "student"))
            if (
                moment().isAfter(liveMoment.clone().add(15, "minutes")) ||
                moment().isSameOrAfter(liveMoment.clone().add(15, "minutes"))
            ) {
                setTimeout(() => {
                    DialogM.show({
                        text1: `Qu'as-tu pensé de cette session LIVE avec ${props.currentLiveSession.tutor?.display_name}`,
                        component: (
                            <LiveSessionDialogComponent
                                navigation={navigation}
                            />
                        ),
                        hideButton1: true,
                        buttonText2: "Pas maintenant",
                        onPressBack: () => {
                            props.apiRequest(liveService.leaveLiveSession, {
                                id: props.liveSessionId,
                            })
                        },
                        exitButton: true,
                    })
                }, 200)
            } else
                props.apiRequest(liveService.leaveLiveSession, {
                    id: props.liveSessionId,
                })
    }

    const endSession = () => {
        props.apiRequest(liveService.finalizeLiveSession, {
            id: props.liveSessionId,
        })
    }

    const { disconnectFromLive } = useDisconnectFromLive()

    const isSoundMode =
        hasRole(props.user, "student") &&
        props.soundModeIds?.includes(props.user?.id)

    const isTutor = hasRole(props.user, "tutor")

    // Tutor camera obstruction detection (web only — hook is a no-op on native).
    // Detects when the tutor covers their camera lens and surfaces a Google
    // Meet-style badge + popover on the camera button.
    const {
        isObstructed: camObstructedWarning,
        popoverVisible: camObstructedPopoverVisible,
        dismissPopover: onDismissObstructedPopover,
        closeOutObstructedState: closeOutCameraObstruction,
    } = useTutorCameraObstructionDetection({ enabled: IS_WEB && isTutor })

    const debouncedOnOffCam = useCameraStateRecorder()

    useApiStatus(
        liveService.sendSatisfaction,
        null,
        true,
        () => {},
        () => {}
    )
    useApiStatus(liveService.leaveLiveSession, false, true, () => {
        // Record the end before destroy() flushes and resets the shared buffer.
        closeOutCameraObstruction()
        disconnectFromLive()
        props.apiIdle(liveService.sendSatisfaction)
        props.apiIdle(liveService.sendStudentComment)
    })
    useApiStatus(
        liveService.finalizeLiveSession,
        false,
        true,
        (successData) => {
            closeOutCameraObstruction()
            triggerFinalizeLive("finalizeLive", {
                id: props.user?.id,
            })
            navigation.push(
                isTutor ? "study-mission-prescription" : "quality-closure",
                {
                    occurrence_id: successData?.id,
                    liveSessionId: props.liveSessionId,
                }
            )
            // The session is over: leave the call now, not when the reports are
            // done. The reports are then recorded outside the live — on iOS a
            // recorder started while the call holds the mic got silence, or was
            // refused outright. The screens above are in both stacks, so they
            // survive the switch out of live mode; the live screen unmounts and
            // disconnects the room.
            props.apiRequest(liveService.leaveLiveSession, {
                id: props.liveSessionId,
            })
        }
    )

    const insets = useSafeAreaInsets()

    return (
        <View
            style={{
                backgroundColor: theme.colors.white,
                justifyContent: "center",
                alignItems: "center",
                height,
                borderTopWidth: 1,
                borderColor: theme.colors.lightMore,
                paddingBottom: insets.bottom,
            }}
        >
            {hasRole(props.user, "tutor") &&
                liveSession?.users
                    ?.filter((x) => !x?.is_tutor)
                    ?.map((user, index) => (
                        <OutOfAppAlert
                            key={index}
                            user={user}
                            participants={liveSession?.users}
                        />
                    ))}
            <View
                style={{
                    width: dimensions?.width > 700 ? "100%" : dimensions?.width,
                    flexDirection: "row",
                    justifyContent:
                        dimensions?.width > 700 ? "space-between" : "center",
                    alignItems: "center",
                    alignSelf: "center",
                    paddingHorizontal: dimensions?.width > 700 ? 20 : 0,
                }}
            >
                {dimensions?.width > 700 && (
                    <TouchableRippleM
                        style={{
                            alignItems: "center",
                            width: 210,
                        }}
                        disabled={true}
                    >
                        <>
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <IconImageM source={live} width={36} />
                                <View>
                                    <TextM
                                        fontSize={16}
                                        fontWeight={"ExtraBold"}
                                        color={theme.colors.success}
                                        style={{
                                            paddingLeft: 5,
                                        }}
                                    >
                                        LIVE{" "}
                                        <TextM
                                            fontSize={15}
                                            fontWeight={"Light"}
                                            color={theme.colors.success}
                                            style={{}}
                                            wrap
                                        >
                                            {liveSession?.live_room?.name}
                                        </TextM>
                                    </TextM>
                                    <TextM
                                        fontSize={11}
                                        fontWeight={"Light"}
                                        ellipsizeMode={"tail"}
                                        color={theme.colors.success}
                                        style={{
                                            paddingLeft: 5,
                                            marginTop: -2,
                                        }}
                                    >
                                        {moment(liveMoment)?.format(
                                            "ddd D MMM HH:mm"
                                        )}
                                    </TextM>
                                </View>
                                <View
                                    style={{
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "row",
                                        paddingLeft: 12,
                                        marginLeft: 12,
                                        borderLeftWidth: 1,
                                        borderColor: theme.colors.lightMore,
                                        height: 24,
                                    }}
                                >
                                    <TextM
                                        fontSize={14}
                                        fontWeight={"Medium"}
                                        ellipsizeMode={"tail"}
                                        color={theme.colors.success}
                                        style={{}}
                                        wrap
                                    >
                                        {moment()?.format("HH:mm")}
                                    </TextM>
                                </View>
                            </View>
                        </>
                    </TouchableRippleM>
                )}

                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingLeft: dimensions?.width > 700 ? 12 : 0,
                        marginLeft: dimensions?.width > 700 ? 12 : 0,
                    }}
                >
                    <ControlBarM
                        pinnedMode={pinnedMode}
                        setPinnedMode={setPinnedMode}
                        isSoundMode={isSoundMode || isTutor}
                        onDeviceError={(error, source) => {
                            console.log("Device error", error, source)
                        }}
                        onOffCam={debouncedOnOffCam}
                        width={null}
                        micWarning={micWarning}
                        camWarning={camWarning}
                        onMicWarningPress={() => openTroubleshooting(PROBLEMS.MIC_NOT_WORKING)}
                        onCamWarningPress={() => openTroubleshooting(PROBLEMS.CAMERA_NOT_WORKING)}
                        onOpenHelp={() => openTroubleshooting(detectedProblem)}
                        camObstructedWarning={camObstructedWarning}
                        camObstructedPopoverVisible={camObstructedPopoverVisible}
                        onDismissObstructedPopover={onDismissObstructedPopover}
                    />
                    {/* Native inline only on wide screens; on small screens it
                        moves to the 3-dot menu below (web inline lives in
                        ControlBarM.web, also width-gated). */}
                    {!IS_WEB && dimensions?.width > 700 && (
                        <CustomIconButton
                            icon={isScreenShareEnabled ? "rectangle-xmark" : "display"}
                            useFA6
                            disabled={isScreenShareLoading}
                            onPress={onScreenSharePress}
                        />
                    )}
                    {dimensions?.width > 700 && (
                        <CustomIconButton
                            icon={"comments"}
                            iconColor={theme.colors.primary}
                            containerColor={color}
                            disabled={buttonsDisabled}
                            badgeCount={
                                (liveSession?.unread_private_messages_count ??
                                    0) +
                                (liveSession?.unread_messages_count ?? 0)
                            }
                            onPress={() => {
                                navigation?.setParams({
                                    ...route?.params,
                                    liveChatUserId: 0,
                                })
                            }}
                        />
                    )}
                    <LayoutToggleM
                        pinnedMode={pinnedMode}
                        setPinnedMode={setPinnedMode}
                    />

                    <ModalM
                        visible={openGoldenRules}
                        withExitButton
                        onDismiss={() => setOpenGoldenRules(false)}
                    >
                        <TutorResources nav={navigation} />
                    </ModalM>

                    <Menu3Point
                        customButtonComponent={
                            <View
                                style={{
                                    backgroundColor: theme.colors.lighter,
                                    borderRadius: 20,
                                    paddingVertical: 10,
                                    paddingHorizontal: 10,
                                    marginHorizontal: 10,
                                }}
                            >
                                <FontAwesome5
                                    style={{}}
                                    name={"ellipsis-v"}
                                    size={20}
                                    color={theme.colors.primary}
                                />
                            </View>
                        }
                        menuItems={[
                            ...(!isIndividual
                                ? [
                                      {
                                          icon: "volume-mute",
                                          title: "Mettre tous en mode concentré",
                                          onPress: () => {
                                              props.apiRequest(
                                                  liveServiceV2.setSoundModeV2,
                                                  { id: props.liveSessionId },
                                                  {
                                                      enabled: false,
                                                      user_ids:
                                                          studentParticipants?.map(
                                                              (u) => u?.id
                                                          ),
                                                  }
                                              )
                                          },
                                      },
                                      {
                                          icon: "volume-up",
                                          title: "Mettre tous en mode dialogue",
                                          onPress: () => {
                                              props.apiRequest(
                                                  liveServiceV2.setSoundModeV2,
                                                  { id: props.liveSessionId },
                                                  {
                                                      enabled: true,
                                                      user_ids:
                                                          studentParticipants?.map(
                                                              (u) => u?.id
                                                          ),
                                                  }
                                              )
                                          },
                                      },
                                  ]
                                : []),
                            {
                                icon: "hand-paper",
                                title: "Baisser toutes les mains",
                                onPress: () => {
                                    props.apiRequest(
                                        liveService.lowerAllHands,
                                        { id: props.liveSessionId }
                                    )
                                },
                            },
                            {
                                icon: "plus",
                                title: "Nouvelle activité commune",
                                onPress: () => {
                                    setShowGenerateActivityModal(true)
                                },
                            },
                            {
                                icon: "book-open",
                                title: "Ressources du tuteur",
                                onPress: () => {
                                    setOpenGoldenRules(true)
                                },
                            },
                            {
                                icon: "stethoscope",
                                title: "Un problème ?",
                                onPress: () => {
                                    openTroubleshooting(detectedProblem)
                                },
                            },
                            ...(dimensions?.width <= 700
                                ? [
                                      {
                                          icon: "comments",
                                          title: "Messages",
                                          onPress: () => {
                                              navigation?.setParams({
                                                  ...route?.params,
                                                  liveChatUserId: 0,
                                              })
                                          },
                                      },
                                      {
                                          icon: isScreenShareEnabled
                                              ? "rectangle-xmark"
                                              : "display",
                                          useFA6: true,
                                          title: isScreenShareEnabled
                                              ? "Arrêter le partage"
                                              : "Partager l'écran",
                                          masked: !canScreenShare,
                                          onPress: onScreenSharePress,
                                      },
                                      ...(!IS_WEB
                                          ? [
                                                {
                                                    icon: "camera-rotate",
                                                    useFA6: true,
                                                    title: "Retourner camera",
                                                    onPress: () => {
                                                        switchCamera()
                                                    },
                                                },
                                            ]
                                          : []),
                                  ]
                                : []),
                        ]}
                        optionStyle={{
                            width: 200,
                        }}
                    />

                    <TouchableRippleM
                        onPress={() => {
                            setMiniMode(true)
                            onExitPress(
                                exit,
                                endSession,
                                isFinalized,
                                liveSession?.tutor,
                                props.user
                            )
                            amplitude.track("button.clicked." + "exit_live")
                        }}
                        style={{
                            alignItems: "center",
                            justifyContent: "center",
                            alignSelf: "center",
                            height: 44,
                            width: 75,
                            backgroundColor: theme.colors.error,
                            borderRadius: 20,
                            marginLeft: 5,
                            opacity:
                                props.leaveLiveSessionRequest ||
                                props.finalizeLiveSessionRequest ||
                                buttonsDisabled
                                    ? 0.5
                                    : 1,
                        }}
                        disabled={
                            props.leaveLiveSessionRequest ||
                            props.finalizeLiveSessionRequest ||
                            buttonsDisabled
                        }
                    >
                        {props.leaveLiveSessionRequest ||
                        props.finalizeLiveSessionRequest ? (
                            <ActivityIndicator
                                color={theme.colors.white}
                                small
                            />
                        ) : (
                            <FontAwesome5
                                name="phone"
                                size={24}
                                color={theme.colors.white}
                                style={{
                                    transform: [
                                        {
                                            rotate: "225deg",
                                        },
                                    ],
                                }}
                            />
                        )}
                    </TouchableRippleM>

                    {isTrial && studentParticipants?.length > 0 && (
                        <TouchableRippleM
                            onPress={() => {
                                openCalendly(studentParticipants?.[0])
                            }}
                            style={{
                                paddingHorizontal: 8,
                                paddingVertical: 4,
                                borderRadius: 4,
                                marginLeft: 20,
                            }}
                        >
                            <View
                                style={{
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <TextM
                                    fontSize={16}
                                    fontWeight={"Bold"}
                                    color={theme.colors.primary}
                                    style={{ textDecorationLine: "underline" }}
                                >
                                    Prendre RDV
                                </TextM>
                                <TextM
                                    fontSize={16}
                                    fontWeight={"Bold"}
                                    color={theme.colors.primary}
                                    style={{ textDecorationLine: "underline" }}
                                >
                                    avec un coordinateur
                                </TextM>
                            </View>
                        </TouchableRippleM>
                    )}
                </View>
                {dimensions?.width > 700 && <View style={{ width: 210 }} />}
            </View>

            <View
                style={{
                    backgroundColor: theme.colors.successLightMore,
                    width: Dimensions?.get("window")?.width,
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    bottom: -12,
                    flexDirection: "row",
                    borderColor: theme.colors.lightMore,
                    gap: 40,
                }}
            >
                <PermissionBanner />
            </View>

            <TroubleshootingPanel
                visible={showTroubleshootingPanel}
                onDismiss={() => setShowTroubleshootingPanel(false)}
                isSoundMode={true}
                role="tutor"
                initialProblem={troubleshootInitialProblem}
                micLevel={micLevel}
                permissionsGranted={permissionsGranted}
                requestPermissions={requestPermissions}
                onOpenReport={() => {
                    setShowTroubleshootingPanel(false)
                    setTimeout(() => setShowHelpModal(true), 300)
                }}
            />
            <LiveHelpModal
                visible={showHelpModal}
                onDismiss={() => setShowHelpModal(false)}
                liveSessionId={props.liveSessionId}
            />

            {/* Generate Activity Modal for multi-student */}
            {showGenerateActivityModal && (
                <GenerateActivityModal
                    isOpen={showGenerateActivityModal}
                    onClose={() => setShowGenerateActivityModal(false)}
                    student={null}
                    schoolSubjects={props.schoolSubjects}
                    forStudents={true}
                    studentsList={studentParticipants}
                    nav={navigation}
                />
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        successes: state.data.staticData?.successes,
        liveSessionId: state.liveMode?.liveSessionId,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        conferenceToken: state.liveMode?.conferenceToken,
        participants: state.liveMode?.liveParticipants,
        inCallUsers: state.liveMode?.inCallUsers,
        raisedHands: state.liveMode?.raisedHands,
        sound: state.liveMode?.sound,
        timesSinceLastCall: state.liveMode?.timesSinceLastCall,
        notes: state.data.tutors?.notes,
        soundMode: state.liveMode?.soundMode,
        isAudioMuted: state.liveMode?.isAudioMuted,
        callPortal: state.liveMode?.callPortal,
        leaveLiveSessionRequest: state.api.leaveLiveSession?.request,
        finalizeLiveSessionRequest: state.api.finalizeLiveSession?.request,
        raiseHandRequest: state.api.raiseHand?.request,
        raiseHandV2Request: state.api.raiseHandV2?.request,
        todayLiveSessionLogs: state.liveMode?.todayLiveSessionLogs,
        callKeepUUID: state.liveMode?.callKeepUUID,
        sendSatisfactionSuccess: state.api.sendSatisfaction?.success,
        soundModeIds: state.liveMode?.soundModeIds,
        schoolSubjects: state.data.staticData?.school_subjects,
        isFocusScreenShare: state.liveMode?.isFocusScreenShare,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setIsLiveModeEnabled,
    setLiveParticipants,
    setIsTyping,
    setTypingUser,
    setInCallUsers,
    removeInCallUsers,
    setCallPortal,
    playASound,
    setFocusScreenShare,
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveModeFooter)
